import { render, staticRenderFns } from "./Decision.vue?vue&type=template&id=376ab6b2&scoped=true&"
import script from "./Decision.vue?vue&type=script&lang=js&"
export * from "./Decision.vue?vue&type=script&lang=js&"
import style0 from "./Decision.vue?vue&type=style&index=0&id=376ab6b2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376ab6b2",
  null
  
)

export default component.exports